module.exports = {
  'en-us': {
    survey: {
      rateCta: 'How would you rate the support you received?',
      ratingGoodLong: "Good, I'm satisfied",
      ratingGoodShort: 'Good',
      ratingBadLong: "Bad, I'm unsatisfied",
      ratingBadShort: 'Bad',
      commentCta: 'Add a comment about the quality of support you received (optional):',
      submitButtonText: 'Submit',
      success1: 'We thank you for your time spent taking this survey.',
      success2: 'Your response has been recorded.',
      error: 'Something went wrong, please try again.',
    },
  },
  de: {
    survey: {
      rateCta: 'Wie bewerten Sie die erhaltene Unterstützung?',
      ratingGoodLong: 'Gut, ich bin zufrieden',
      ratingGoodShort: 'Gut',
      ratingBadLong: 'Schlecht, ich bin unzufrieden',
      ratingBadShort: 'Schlecht',
      commentCta: 'Fügen Sie einen Kommentar zur Qualität des erhaltenen Supports hinzu (optional):',
      submitButtonText: 'einreichen',
      success1: 'Wir danken Ihnen für Ihre Zeit, die Sie für diese Umfrage aufgewendet haben.',
      success2: 'Ihre Antwort wurde aufgezeichnet.',
      error: 'Etwas ist schief gelaufen. Bitte versuche es erneut.',
    },
  },
  fr: {
    survey: {
      rateCta: 'Comment évalueriez-vous le soutien que vous avez reçu?',
      ratingGoodLong: 'Bien, je suis satisfait',
      ratingGoodShort: 'Bon',
      ratingBadLong: 'Mauvais, je suis insatisfait',
      ratingBadShort: 'Mal',
      commentCta: 'Ajoutez un commentaire sur la qualité du support que vous avez reçu (facultatif):',
      submitButtonText: 'Soumettre',
      success1: 'Nous vous remercions de votre temps passé à prendre cette enquête.',
      success2: 'Votre réponse a été enregistrée.',
      error: "Une erreur s'est produite. Veuillez réessayer.",
    },
  },
  it: {
    survey: {
      rateCta: 'Come valuteresti il ​​supporto ricevuto?',
      ratingGoodLong: 'Buono, sono soddisfatto',
      ratingGoodShort: 'Bene',
      ratingBadLong: 'Male, sono insoddisfatto',
      ratingBadShort: 'Cattivo',
      commentCta: 'Aggiungi un commento sulla qualità del supporto ricevuto (facoltativo):',
      submitButtonText: 'Invia',
      success1: 'Vi ringraziamo per il tuo tempo trascorso a prendere questo sondaggio.',
      success2: 'La tua risposta è stata registrata.',
      error: 'Qualcosa è andato storto, prova ancora.',
    },
  },
  ja: {
    survey: {
      rateCta: 'あなたが受け取ったサポートをどのように評価しますか？',
      ratingGoodLong: '良い、私は満足しています',
      ratingGoodShort: '良い',
      ratingBadLong: '悪い、私は満足しています',
      ratingBadShort: '悪い',
      commentCta: '受信したサポートの品質に関するコメントを追加します（オプション）。',
      submitButtonText: '送信',
      success1: 'この調査を受けた時間に感謝します。',
      success2: 'あなたの応答は記録されました。',
      error: '何かが間違っていました。もう一度やり直してください。',
    },
  },
  pt: {
    survey: {
      rateCta: 'Como você avaliaria o apoio que você recebeu?',
      ratingGoodLong: 'Bom, eu estou satisfeito',
      ratingGoodShort: 'Boa',
      ratingBadLong: 'Ruim, eu estou insatisfeito',
      ratingBadShort: 'Mau',
      commentCta: 'Adicione um comentário sobre a qualidade do suporte que você recebeu (opcional):',
      submitButtonText: 'Enviar',
      success1: 'Agradecemos pelo seu tempo gasto fazendo esta pesquisa.',
      success2: 'Sua resposta foi gravada.',
      error: 'Alguma coisa deu errado. Por favor tente outra vez.',
    },
  },
  es: {
    survey: {
      rateCta: '¿Cómo calificaría el apoyo que recibió?',
      ratingGoodLong: 'Bien, estoy satisfecho',
      ratingGoodShort: 'Bien',
      ratingBadLong: 'Mal, estoy insatisfecho',
      ratingBadShort: 'Malo',
      commentCta: 'Agregue un comentario sobre la calidad del soporte que recibió (opcional):',
      submitButtonText: 'Entregar',
      success1: 'Le agradecemos su tiempo dedicado a tomar esta encuesta.',
      success2: 'Su respuesta ha sido registrada.',
      error: 'Algo salió mal. Por favor, vuelva a intentarlo.',
    },
  },
};
